import React from "react";
import { SectionHeader } from "../../../common/WorkspaceChrome";
import { ReportsView } from "../../reports/ReportsView";

export function AnalyticsTab({ analyticsRows }) {
  return (
    <>
      <section className="panel">
        <SectionHeader
          eyebrow="Analytics"
          title="Dashboard analytics"
          text="Business signals from work, attendance, sales, finance, and delivery data."
        />
      </section>
      <section className="metrics-grid analytics-metrics" aria-label="Dashboard analytics">
        {analyticsRows.map((item) => (
          <article className="metric-card" key={item.label}>
            <span>{item.label}</span>
            <strong>{item.value}</strong>
            <small>{item.note}</small>
          </article>
        ))}
      </section>
      <ReportsView />
    </>
  );
}
